module.exports = __webpack_public_path__ + "static/media/industries-cheramic-s.6ff14b2a.jpg";